import * as React from 'react';
import * as classNames from 'classnames';
import SplitPane from 'react-split-pane';
import debounce = require('lodash/debounce');

import './styles.sass';

export interface ISessionSplitPaneProps {
  children?: any;
  leftBarHidden: boolean;
  toggleLeftBar: (state?: boolean) => void;
}

interface ISessionSplitPaneState {
  splitPaneMaxSize?: number;
  splitPaneSize?: number;
}

/**
 * @TODO: calculate width
 * left bar shouldn't contain arrows even when it's less than 25% of window width
 */
const NAV_TABS_WIDTH: number = 271;    /* width of nav tabs */
const CLOSE_BUTTON_WIDTH: number = 32; /* width of close button */
const DELTA_OFFSET: number = 0.35;
const MIN_LEFT_BAR_SIZE: number = 15;
const PANELS_LENGTH: number = 2;

export class SessionSplitPane extends React.Component<ISessionSplitPaneProps, ISessionSplitPaneState> {
  public state: ISessionSplitPaneState = {
    splitPaneMaxSize: 0,
    splitPaneSize: 0,
  };
  private onWindowResize: any = debounce((): void => this.setWidth());

  public render(): React.ReactElement<any> {
    const {
      splitPaneMaxSize,
      splitPaneSize,
    } = this.state;

    const {
      leftBarHidden,
      children,
    } = this.props;


    const splitPaneClassName = classNames({
      'session-split-pane_closed': leftBarHidden,
    });

    return (
      <div className={'session-split-pane'}>
        <SplitPane
          className={splitPaneClassName}
          maxSize={splitPaneMaxSize}
          minSize={0}
          split={'vertical'}
          size={splitPaneSize}
          onChange={this.onSplitPaneChange}
        >
          {children.slice(0, PANELS_LENGTH)}
        </SplitPane>

        {children.slice(PANELS_LENGTH)}
      </div>
    );
  }

  public componentDidMount(): void {
    window.addEventListener('resize', this.onWindowResize);
    this.toggleLeftBar();
  }

  public componentDidUpdate(props: ISessionSplitPaneProps): void {
    if (this.props.leftBarHidden !== props.leftBarHidden) {
      this.toggleLeftBar();
    }
  }

  public componentWillUnmount(): void {
    window.removeEventListener('resize', this.onWindowResize);
  }

  private setWidth = (): void => {
    this.setState({splitPaneMaxSize: window.innerWidth, splitPaneSize: this.calculateSplitPaneSize()});
  }

  private toggleLeftBar = (): void => {
    this.setState({splitPaneSize: this.props.leftBarHidden ? 0 : this.calculateSplitPaneSize()});
  };

  private onSplitPaneChange = (size: number): void => {
    if (size <= MIN_LEFT_BAR_SIZE) {
      this.props.leftBarHidden || this.props.toggleLeftBar(true);
    } else {
      this.props.leftBarHidden && this.props.toggleLeftBar(false);
    }
  };

  private calculateSplitPaneSize = (): number => {
    return Math.max(NAV_TABS_WIDTH + CLOSE_BUTTON_WIDTH, DELTA_OFFSET * window.innerWidth);
  }
}
